import React from 'react';
import PropTypes from 'prop-types';

// adapted from https://stackoverflow.com/a/47803998/32009

function escapeRegExp(string) {
  return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

function HighlightedText({ highlight, highlightProps, text }) {
  if (!highlight.trim()) {
    return <span>{text}</span>;
  }

  const regex = new RegExp(`(${escapeRegExp(highlight)})`, 'gi');
  const parts = text.split(regex);

  return parts.filter((part) => part).map((part, index) => (
    <React.Fragment key={`${part}${index.toString()}`}>
      {regex.test(part) ? <mark {...highlightProps}>{part}</mark> : part}
    </React.Fragment>
  ));
}

HighlightedText.propTypes = {
  highlight: PropTypes.string,
  highlightProps: PropTypes.object,
  text: PropTypes.string,
};

HighlightedText.defaultProps = {
  highlight: '',
  highlightProps: {},
  text: '',
};

export default HighlightedText;
